import {
    Card,
    Grid,
    IconButton, Link,
    Stack,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow, Typography
} from "@mui/material";
import React from "react";
import {showAmount, SmartLink} from "../abelcommon";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import {Link as RouterLink} from "react-router-dom";
import {messageForPrivacyLevel} from './PrivacyLevel'

interface AddressTxItemProps {
    txid: string;
    inputs: number;
    outputs: number;
    fee: number;
    version: number;
    size: number;
    fullSize: number;
}


const AddressTxItem = ({txid, inputs, outputs, fee, version, size, fullSize}: AddressTxItemProps) => {
    return (
        <Card sx={{
            margin: 1,
            padding: 1,
            display: 'flex',
            boxShadow: 3,
            borderRadius: 2,
            width: 1,
            minHeight: 66,
            height: 66,
            overflow: 'auto',
        }}>
            <Grid container direction="row" spacing={1}>
                <Grid item xs={8}>
                    <Typography variant="body2">
                        {`TXID: `}
                        <Link component={RouterLink} to={`/tx/0x${txid}`}>
                            {txid}...
                        </Link>
                    </Typography>
                </Grid>
                <Grid item xs={2}>
                    <Typography variant="body2">
                        {`Version: ${version}`}
                    </Typography>
                </Grid>
                <Grid item xs={2}>
                    <Typography variant="body2">
                        {`Value: ${fee} ABEL`}
                    </Typography>
                </Grid>
                <Grid item xs={4}>
                    <Typography variant="body2">
                        {`Size: ${size}`}
                    </Typography>
                </Grid>
                <Grid item xs={4}>
                    <Typography variant="body2">
                        {`Full Size: ${fullSize}`}
                    </Typography>
                </Grid>
                <Grid item xs={2}>
                    <Typography variant="body2">
                        {`From: ${inputs}`}
                    </Typography>
                </Grid>
                <Grid item xs={2}>
                    <Typography variant="body2">
                        {`To: ${outputs}`}
                    </Typography>
                </Grid>
            </Grid>
        </Card>
    );
}

function AddressRow({data, i, allowExpand}: { data: any, i: number, allowExpand: boolean }) {
    const [open, setOpen] = React.useState(false);

    return (
        <>
            <TableRow key={i} onClick={() => setOpen(!open)} sx={{height: 60}}>
                <TableCell>
                    <SmartLink to={`/address/0x${data.address}`}>
                        0x{data.address.slice(0, 8) + '..' + data.address.slice(-8)}
                        {data.address && '*'.repeat(6)}
                    </SmartLink>
                </TableCell>
                <TableCell>
                    <Typography variant={'body2'}>{messageForPrivacyLevel(data.privacyLevel)}</Typography>
                </TableCell>
                <TableCell sx={{
                    display: {
                        xs: 'none', // theme.breakpoints.up('sm')
                        sm: 'none', // theme.breakpoints.up('sm')
                        md: 'table-cell', // theme.breakpoints.up('md')
                        // lg: 'table-cell', // theme.breakpoints.up('lg')
                        // xl: 'table-cell', // theme.breakpoints.up('xl')
                    }
                }}>
                    <SmartLink to={`/address/0x${data.address}?tab=1`}>
                        <Typography variant={'body2'}>{data.txn}</Typography>
                    </SmartLink>
                </TableCell>
                <TableCell sx={{
                        display: {
                            xs: 'none', // theme.breakpoints.up('sm')
                            sm: 'none', // theme.breakpoints.up('sm')
                            md: 'table-cell', // theme.breakpoints.up('md')
                            // lg: 'table-cell', // theme.breakpoints.up('lg')
                            // xl: 'table-cell', // theme.breakpoints.up('xl')
                        }
                    }}>
                    <Typography variant={'body2'}>{showAmount(data.privacyLevel, data.totalReceived)}</Typography>
                </TableCell>
                <TableCell sx={{
                        display: {
                            xs: 'none', // theme.breakpoints.up('sm')
                            sm: 'none', // theme.breakpoints.up('sm')
                            md: 'table-cell', // theme.breakpoints.up('md')
                            // lg: 'table-cell', // theme.breakpoints.up('lg')
                            // xl: 'table-cell', // theme.breakpoints.up('xl')
                        }
                    }}>
                    <Typography variant={'body2'}>{showAmount(data.privacyLevel, data.totalSent)}</Typography>
                </TableCell>
                <TableCell align={'right'} sx={{
                        display: {
                            xs: 'none', // theme.breakpoints.up('sm')
                            sm: 'none', // theme.breakpoints.up('sm')
                            md: 'table-cell', // theme.breakpoints.up('md')
                            // lg: 'table-cell', // theme.breakpoints.up('lg')
                            // xl: 'table-cell', // theme.breakpoints.up('xl')
                        }
                    }}>
                    <SmartLink to={`/block/${data.firstBlockHeight}`}>{data.firstBlockHeight}</SmartLink>
                </TableCell>
                <TableCell align={'right'} sx={{
                        display: {
                            xs: 'none', // theme.breakpoints.up('sm')
                            sm: 'none', // theme.breakpoints.up('sm')
                            md: 'table-cell', // theme.breakpoints.up('md')
                            // lg: 'table-cell', // theme.breakpoints.up('lg')
                            // xl: 'table-cell', // theme.breakpoints.up('xl')
                        }
                    }}>
                    <SmartLink to={`/block/${data.lastBlockHeight}`}>{data.lastBlockHeight}</SmartLink>
                </TableCell>
                <TableCell align={'right'} sx={{
                        display: {
                            xs: 'none', // theme.breakpoints.up('sm')
                            sm: 'none', // theme.breakpoints.up('sm')
                            md: 'table-cell', // theme.breakpoints.up('md')
                            // lg: 'table-cell', // theme.breakpoints.up('lg')
                            // xl: 'table-cell', // theme.breakpoints.up('xl')
                        }
                    }}>
                    <Typography variant={'body2'}>{showAmount(data.privacyLevel, data.balance)}</Typography>
                </TableCell>
                {allowExpand && <TableCell align={'right'}>
                    <IconButton
                        aria-label="expand row"
                        size="small"
                        sx={{bgcolor: 'transparent'}}
                        // onClick={() => setOpen(!open)}
                    >
                        {open ? <KeyboardArrowUpIcon/> : <KeyboardArrowDownIcon/>}
                    </IconButton>
                </TableCell>}
            </TableRow>
            {allowExpand && <TableRow key={`address_${i}`}>
                <TableCell style={{paddingBottom: 0, paddingTop: 0}} colSpan={10}>
                    <Stack direction='column' spacing={1} sx={{maxHeight: 400, overflow: 'auto'}}>
                        {open && data.txs.map((tx: any) => {
                            return (
                                <AddressTxItem key={`address_tx_${tx.id}`}
                                               txid={tx.id} inputs={tx.inputs} outputs={tx.outputs}
                                               fee={tx.fee} version={tx.version} size={tx.size} fullSize={tx.fullSize}
                                />
                            )
                        })}
                    </Stack>
                </TableCell>
            </TableRow>}
        </>
    );
}

interface AddressListProps {
    data: any[]
    allowExpand?: boolean
}

export function AddressList({data, allowExpand = false}: AddressListProps) {
    return (
        <TableContainer sx={{width: {xs: 'auto', sm: 1}}}>
            <Table
                sx={{
                    width: '100%',
                    tableLayout: 'auto',
                    '& .MuiTableCell-root': {px: 1, py: 0.5},
                }}
            >
                <TableHead sx={{'& .MuiTableCell-root': {fontWeight: 'bold'}}}>
                    <TableRow>
                        <TableCell>Address</TableCell>
                        <TableCell>Privacy Level</TableCell>
                        <TableCell sx={{
                            display: {
                                xs: 'none', // theme.breakpoints.up('sm')
                                sm: 'none', // theme.breakpoints.up('sm')
                                md: 'table-cell', // theme.breakpoints.up('md')
                                // lg: 'table-cell', // theme.breakpoints.up('lg')
                                // xl: 'table-cell', // theme.breakpoints.up('xl')
                            }
                        }}>
                            Transactions
                        </TableCell>
                        <TableCell sx={{
                            display: {
                                xs: 'none', // theme.breakpoints.up('sm')
                                sm: 'none', // theme.breakpoints.up('sm')
                                md: 'table-cell', // theme.breakpoints.up('md')
                                // lg: 'table-cell', // theme.breakpoints.up('lg')
                                // xl: 'table-cell', // theme.breakpoints.up('xl')
                            }
                        }}>
                            Total Received
                        </TableCell>
                        <TableCell sx={{
                            display: {
                                xs: 'none', // theme.breakpoints.up('sm')
                                sm: 'none', // theme.breakpoints.up('sm')
                                md: 'table-cell', // theme.breakpoints.up('md')
                                // lg: 'table-cell', // theme.breakpoints.up('lg')
                                // xl: 'table-cell', // theme.breakpoints.up('xl')
                            }
                        }}>
                            Total Sent
                        </TableCell>
                        <TableCell align={'right'} sx={{
                            display: {
                                xs: 'none', // theme.breakpoints.up('sm')
                                sm: 'none', // theme.breakpoints.up('sm')
                                md: 'table-cell', // theme.breakpoints.up('md')
                                // lg: 'table-cell', // theme.breakpoints.up('lg')
                                // xl: 'table-cell', // theme.breakpoints.up('xl')
                            }
                        }}>
                            First Block
                        </TableCell>
                        <TableCell align={'right'} sx={{
                            display: {
                                xs: 'none', // theme.breakpoints.up('sm')
                                sm: 'none', // theme.breakpoints.up('sm')
                                md: 'table-cell', // theme.breakpoints.up('md')
                                // lg: 'table-cell', // theme.breakpoints.up('lg')
                                // xl: 'table-cell', // theme.breakpoints.up('xl')
                            }
                        }}>
                            Last Block
                        </TableCell>
                        <TableCell align={'right'} sx={{
                            display: {
                                xs: 'none', // theme.breakpoints.up('sm')
                                sm: 'none', // theme.breakpoints.up('sm')
                                md: 'table-cell', // theme.breakpoints.up('md')
                                // lg: 'table-cell', // theme.breakpoints.up('lg')
                                // xl: 'table-cell', // theme.breakpoints.up('xl')
                            }
                        }}>
                            Balance
                        </TableCell>
                        <TableCell align={'right'} sx={{
                            display: {
                                xs: 'none', // theme.breakpoints.up('sm')
                                sm: 'none', // theme.breakpoints.up('sm')
                                md: 'table-cell', // theme.breakpoints.up('md')
                                // lg: 'table-cell', // theme.breakpoints.up('lg')
                                // xl: 'table-cell', // theme.breakpoints.up('xl')
                            }
                        }}>

                        </TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {data.map((d, i) => <AddressRow
                        key={`${d.address}_tx_${i}`}
                        allowExpand={allowExpand}
                        data={d}
                        i={i}/>)}
                </TableBody>
            </Table>
        </TableContainer>
    );
}


export default AddressList;
